import { BasicResponse, PagedResponse } from '../types';
import { DasSenseH } from '../types/Device';

import { delay } from '../utils/common';

import DsmAxios from './DsmAxios';

export const getUserDasSensesH = async (params?: {
  dasId?: string;
  id?: string;
  projectId?: string;
  assignedProject?: boolean;
  nextCursor?: string;
  limit?: number;
}) => {
  /**
   * limit too large will cause server response timeout
   */
  let limit = params?.limit ?? 100;
  if (import.meta.env.MODE === 'development') {
    limit = params?.limit ?? 100;
  }
  await delay(100);
  return DsmAxios.get<PagedResponse<DasSenseH>>(`v1/dassenses`, {
    params: {
      ...params,
      limit,
    },
  });
};

export const getProjectDasSensesH = async (data: {
  projectId: string;
  params?: {
    prevCursor?: string;
    nextCursor?: string;
    id?: string;
    dasId?: string;
    assignedWorker?: boolean;
    orderBy?: 'das_id' | 'last_data_point_received_at';
    limit?: number;
  };
}) => {
  /**
   * limit too large will cause server response timeout
   */
  const limit = data.params?.limit ?? 100;

  return DsmAxios.get<PagedResponse<DasSenseH>>(
    `v1/projects/${data.projectId}/dassenses`,
    {
      params: { ...data.params, limit },
    },
  );
};

export const getDasSenseHByDasId = (data: { dasId: string }) => {
  return DsmAxios.get<BasicResponse<DasSenseH>>(`v1/dassenses/${data.dasId}`);
};

export const getWorkerStatOfBodyTemperature = (
  projectId: string,
  params: {
    fromDate?: string;
    toDate?: string;
    workerId: string;
    interval: 'month' | 'hour' | 'day' | 'minute';
  },
) => {
  return DsmAxios.get<
    BasicResponse<{
      intervals: {
        [index: string]: {
          bodyTemperature: number | null;
          ambientTemperature: number | null;
        } | null;
      };
    }>
  >(`v1/projects/${projectId}/workers/stats/body-temperature`, { params });
};

export const bindDasSenseHToWorker = ({
  projectId,
  dasId,
  workerId,
}: {
  projectId: string;
  dasId: string;
  workerId: string;
}) => {
  return DsmAxios.put(`v1/projects/${projectId}/dassenses/${dasId}/worker`, {
    workerId,
  });
};

export const unbindDasSenseH = ({
  projectId,
  dasId,
}: {
  projectId: string;
  dasId: string;
}) => {
  return DsmAxios.delete(`v1/projects/${projectId}/dassenses/${dasId}/worker`);
};
